import ArchonLayout, {
  Background,
  Container,
} from '../../layouts/ArchonLayout/ArchonLayout';
import Seo from '../Seo/Seo';
import React from 'react';
import { ArchonHeaderViewModel } from '../ArchonHeader/ArchonHeader';
import { ArchonFooterViewModel } from '../ArchonFooter/ArchonFooter';
import { AnnouncementPageViewModel } from '../../helpers/getAnnouncementPageViewModels';
import ArchonTitle from '../ArchonTitle/ArchonTitle';
import EnhancedMarkdown from '../../../resources/js/components/EnhancedMarkdown/EnhancedMarkdown';
import enhancedMarkdownOverrides from '../../helpers/enhancedMarkdownOverrides';
import { ViewModels, ViewModelsProvider } from '../../contexts/useViewModels';

type AnnouncementPageProps = {
  header: ArchonHeaderViewModel;
  footer: ArchonFooterViewModel;
  page: AnnouncementPageViewModel;
  viewModels: ViewModels;
};

export default function AnnouncementPage({
  header,
  footer,
  page,
  viewModels,
}: AnnouncementPageProps): JSX.Element {
  const { seo, heading, body } = page;

  return (
    <ViewModelsProvider value={viewModels}>
      <ArchonLayout header={header} footer={footer}>
        <Seo {...seo} />
        <Background />
        <Container>
          <ArchonTitle heading={heading} />
          <EnhancedMarkdown
            markdown={body}
            overrides={enhancedMarkdownOverrides}
          />
        </Container>
      </ArchonLayout>
    </ViewModelsProvider>
  );
}
